import React from 'react';
import { Table, Badge } from 'reactstrap';
import { format } from 'date-fns';
import { AuditTableCodeView } from './AuditTableCodeView';
import { AuditAction } from '.';

interface AuditTableProps {
  data: Array<AuditAction>;
}

const handleBadge = (actionType: string) => {
  const style = { padding: '8px 12px' };
  switch (actionType) {
    case 'Criação': {
      return (
        <Badge color="light-success" pill style={style}>
          {actionType.toUpperCase()}
        </Badge>
      );
    }
    case 'Atualização': {
      return (
        <Badge color="light-primary" pill style={style}>
          {actionType.toUpperCase()}
        </Badge>
      );
    }
    case 'Deleção': {
      return (
        <Badge color="light-danger" pill style={style}>
          {actionType.toUpperCase()}
        </Badge>
      );
    }
    default: {
      return <Badge>{actionType}</Badge>;
    }
  }
};

export const AuditTable: React.FC<AuditTableProps> = ({ data }) => {
  return (
    <Table bordered hover responsive>
      <thead>
        <tr>
          <th>#</th>
          <th>Nome do Usuário</th>
          <th>Email</th>
          <th>Sistema de Origem</th>
          <th>Funcionalidade Alterada</th>
          <th>Caminho da Ação</th>
          <th>Tipo de Ação</th>
          <th>Valor Antigo</th>
          <th>Novo Valor</th>
          <th>Data</th>
        </tr>
      </thead>
      <tbody>
        {data.length > 0 ? (
          data.map((item) => (
            <tr key={item.id}>
              <td>{item.id}</td>
              <td>{item.userName}</td>
              <td>{item.email}</td>
              <td>{item.systemOrigin}</td>
              <td>{item.functionality}</td>
              <td>{item.actionPath}</td>
              <td style={{ fontSize: 18 }}>{handleBadge(item.actionType)}</td>
              <td>
                <AuditTableCodeView jsonData={item.oldValues} />
              </td>
              <td>
                <AuditTableCodeView jsonData={item.newValues} />
              </td>
              <td>{format(new Date(item.createAt), 'dd/MM/yyyy HH:mm:ss')} </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan={9} className="text-center">
              Nenhum resultado encontrado.
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  );
};
